(function () {
  var el = document.getElementById('popsie-email-capture');
  if (!el) return;

  var delay = parseInt(el.getAttribute('data-delay'), 10) || 25;
  var suppressDays = parseInt(el.getAttribute('data-suppress'), 10) || 30;
  var STORAGE_KEY = 'popsie_capture_seen';
  var STORAGE_DAYS_KEY = 'popsie_capture_seen_days';

  if (/[?&]utm_medium=email/i.test(window.location.search)) return;

  var stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    var elapsed = Date.now() - parseInt(stored, 10);
    var maxDays = parseInt(localStorage.getItem(STORAGE_DAYS_KEY) || suppressDays, 10);
    if (elapsed < maxDays * 86400000) return;
  }

  var dialog = el.querySelector('[role="dialog"]');
  var prevFocus;

  // Every Shopify customer form on the page reports posted_successfully after ANY
  // customer-form submit (footer newsletter, PDP waitlist). Only treat it as popup
  // success/error when THIS form was the one submitted (sessionStorage flag set on submit).
  var SUBMIT_FLAG = 'popsie_popup_submitted';
  var wasPopupSubmit = false;
  try {
    wasPopupSubmit = sessionStorage.getItem(SUBMIT_FLAG) === '1';
    if (wasPopupSubmit) sessionStorage.removeItem(SUBMIT_FLAG);
  } catch (e) {}

  if (el.querySelector('[data-success]')) {
    if (wasPopupSubmit) {
      openDialog();
      setSuppress(365);
    }
    return;
  }

  if (wasPopupSubmit && el.querySelector('.popsie-capture-error')) {
    // Server rejected the email: reopen immediately so the error is visible.
    openDialog();
    return;
  }

  var triggered = false;
  var isMobile = window.innerWidth < 750;
  var dwellTimer;
  var scrollFn;

  if (!isMobile) {
    var delayMs = delay * 1000;
    dwellTimer = setTimeout(fire, delayMs);
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0) fire();
    });
  } else {
    var mobileDelayMs = Math.round(delay * 0.8) * 1000;
    dwellTimer = setTimeout(fire, mobileDelayMs);
    scrollFn = function () {
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      if (docH > 0 && window.scrollY / docH >= 0.6) fire();
    };
    window.addEventListener('scroll', scrollFn, { passive: true });
  }

  function fire() {
    if (triggered) return;
    triggered = true;
    clearTimeout(dwellTimer);
    if (scrollFn) window.removeEventListener('scroll', scrollFn);
    openDialog();
  }

  function openDialog() {
    prevFocus = document.activeElement;
    el.removeAttribute('hidden');
    el.setAttribute('open', '');
    var capForm = el.querySelector('form');
    if (capForm && !capForm.dataset.popsieFlagged) {
      capForm.dataset.popsieFlagged = '1';
      capForm.addEventListener('submit', function () {
        try { sessionStorage.setItem(SUBMIT_FLAG, '1'); } catch (e) {}
      });
    }
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    requestAnimationFrame(function () {
      var first = dialog.querySelector(
        'input:not([type="hidden"]):not([disabled]), button:not([disabled]), a[href]'
      );
      if (first) first.focus();
    });
  }

  function closeDialog() {
    el.removeAttribute('open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (prevFocus) prevFocus.focus();
    setSuppress(suppressDays);
  }

  function setSuppress(days) {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    localStorage.setItem(STORAGE_DAYS_KEY, days.toString());
  }

  function focusableList() {
    return dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  function onKey(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeDialog();
      return;
    }
    if (e.key === 'Tab') {
      var items = focusableList();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  var closeBtn = el.querySelector('.popsie-capture-close');
  if (closeBtn) closeBtn.addEventListener('click', closeDialog);

  el.addEventListener('click', function (e) {
    if (e.target === el) closeDialog();
  });
})();
